/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetSeasonBaseResponse
 */
export interface GetSeasonBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetSeasonBaseResponse
     */
    seasonId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetSeasonBaseResponse
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSeasonBaseResponse
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetSeasonBaseResponse interface.
 */
export function instanceOfGetSeasonBaseResponse(value: object): value is GetSeasonBaseResponse {
    if (!('seasonId' in value) || value['seasonId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetSeasonBaseResponseFromJSON(json: any): GetSeasonBaseResponse {
    return GetSeasonBaseResponseFromJSONTyped(json, false);
}

export function GetSeasonBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSeasonBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'seasonId': ApiUserTasksGetPageParameterFromJSON(json['seasonId']),
        'name': json['name'],
        'isActive': json['isActive'],
    };
}

export function GetSeasonBaseResponseToJSON(json: any): GetSeasonBaseResponse {
    return GetSeasonBaseResponseToJSONTyped(json, false);
}

export function GetSeasonBaseResponseToJSONTyped(value?: GetSeasonBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seasonId': ApiUserTasksGetPageParameterToJSON(value['seasonId']),
        'name': value['name'],
        'isActive': value['isActive'],
    };
}

